module.exports = __webpack_public_path__ + "media/images/official/special_hopper_02-2a039884f73fc5a46ad951fc9782bf49.jpg";